import styled from 'styled-components';

export const Credentials = styled.div`
  paddingRight: 20px;
  marginTop: 10px;
  marginBottom: 0;
  zIndex: 1,
`;

const styles = (theme: Object) => ({
  checkBox: {
    marginTop: '-8px',
    paddingLeft: '3px',
    float: 'right',
  },
  checkLabel: {
    color: theme.applyOpacityToHex(theme.palette.greyScale[0], 0.6),
    size: '12px',
  },
  errorBox: {
    backgroundColor: theme.applyOpacityToHex(theme.palette.error.main, 0.1),
    border: `1px solid ${theme.applyOpacityToHex(theme.palette.error.main, 0.5)}`,
    borderRadius: '5px',
    padding: '3px 5px',
  },
  errorButtonWrapper: {
    backgroundColor: theme.palette.greyScale[7],
    bottom: -1,
    position: 'absolute',
    right: 0,
    zIndex: 1,
  },
  errorButton: {
    backgroundColor: theme.applyOpacityToHex(theme.palette.error.main, 0.1),
    padding: '1px 1px',
    '&:hover': {
      backgroundColor: theme.applyOpacityToHex(theme.palette.error.main, 0.25),
    },
  },
  errorText: {
    ...theme.typography.caption,
  },
  expandHighlight: {
    paddingLeft: 4,
    textDecoration: 'underline',
  },
  field: {
    display: 'flex',
    padding: '10px 0',
  },
  form: {
    display: 'flex',
    minHeight: '100%',
    flex: '1 1 auto',
    flexDirection: 'column',
  },
  formActions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: '0px 24px 0px 0px',
  },
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  notAvailable: {
    marginBottom: theme.spacing(2),
  },
  lock: {
    color: '#706e6b',
  },
  nonAmbigousText: {
    textDecoration: 'underline',
  },
  isBusyContainer: {
    paddingTop: '15%',
    width: '100%',
  },
  partnerAuthIntro: {
    paddingTop: 24,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignContent: 'flex-start',
  },
  partnerAuthList: {
    paddingLeft: 30,
    color: theme.palette.greyScale[2],
  },
  partnerListItem: {
    color: theme.palette.greyScale[2],
    paddingBottom: 18,
  },
  partnerAuthActions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  partnerAuthMoreInfoContainer: {
    textAlign: 'center',
    padding: 8,
    '& a': {
      color: theme.palette.greyScale[1],
    },
  },
  partnerAuthSignInContainer: {
    textAlign: 'center',
    padding: '48px 24px',
  },
  errorView: {
    overflow: 'hidden',
    position: 'relative',
    lineHeight: 1,
    color: `${theme.palette.greyScale[1]} !important`,
  },
  whiteBack: {
    backgroundColor: theme.palette.greyScale[7],
  },
});

export default styles;

